export var TripRequestStatus;
(function (TripRequestStatus) {
    TripRequestStatus["PendingStatus"] = "PENDING";
    TripRequestStatus["VerifiedStatus"] = "VERIFIED";
    TripRequestStatus["PostponedStatus"] = "POSTPONED";
    TripRequestStatus["MatchedStatus"] = "MATCHED";
    TripRequestStatus["SoldStatus"] = "SOLD";
    TripRequestStatus["CanceledStatus"] = "CANCELED";
    TripRequestStatus["JunkStatus"] = "JUNK";
    TripRequestStatus["ReferredStatus"] = "REFERRED";
})(TripRequestStatus || (TripRequestStatus = {}));
export var ReferralType;
(function (ReferralType) {
    ReferralType["LifetimePartnerReferral"] = "LIFETIME_PARTNER_REFERRAL";
    ReferralType["OneTimePartnerReferral"] = "ONE_TIME_PARTNER_REFERRAL";
    ReferralType["None"] = "";
})(ReferralType || (ReferralType = {}));
export var TripRequestType;
(function (TripRequestType) {
    TripRequestType["Legacy"] = "LEGACY";
    TripRequestType["Standard"] = "STANDARD";
    TripRequestType["PartnerReferral"] = "PARTNER_REFERRAL";
})(TripRequestType || (TripRequestType = {}));
